module.exports = __webpack_public_path__ + "static/media/MM62-2MTJ.a210cf65.png";